import { useState, useEffect, useRef } from 'react';


export default function CountUp({ end, suffix = '', duration = 800, animate = true }) {
  // determine how many decimal places to show
  const decimalPlaces =
    typeof end === 'number' && end % 1 !== 0
      ? end.toString().split('.')[1].length
      : 0;
  // initialize count: if animate is false, start at end, else start at 0
  const [count, setCount] = useState(() => (animate ? 0 : end));
  const startRef = useRef(null);

  useEffect(() => {
    if (!animate) {
      setCount(end);
      return;
    }
    startRef.current = null;

    function step(timestamp) {
      if (startRef.current === null) startRef.current = timestamp;
      const progress = Math.min((timestamp - startRef.current) / duration, 1);
      // calculate interpolated value with fixed decimals
      const value =
        progress < 1
          ? parseFloat((progress * end).toFixed(decimalPlaces))
          : end;
      setCount(value);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  }, [end, duration, animate, decimalPlaces]);

  // render with fixed decimals if needed
  return (
    <>
      {decimalPlaces > 0 ? count.toFixed(decimalPlaces) : count}
      {suffix}
    </>
  );
}